@if (dialogData) {
  <div>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="{{ 'Search.Details' | translate }}">
        <div class="question-title">
          <mat-label>{{ dialogData.query }}</mat-label>
        </div>
        <mat-dialog-content>
          @if (AIResponse) {
            <markdown [data]="AIResponse"></markdown>
          }
        </mat-dialog-content>
      </mat-tab>
      <mat-tab label="{{ 'Search.Permissions' | translate }}">
        @if (shareData) {
          <app-share-menu [data]="shareData" [canEdit]="true" />
        }
      </mat-tab>
    </mat-tab-group>
  </div>
}
